"use strict";

function initEvents() {
    const $thumbSlider = $(".m-product-detail__thumb-images .slick-slider");
    const $thumbAnnouncer = $("#thumb-carousel-announcer");

    $thumbSlider.on("keydown", function (e) {
        let currentIndex = Number($thumbSlider.find(".slick-current").data("slick-index"));

        if (e.key === "ArrowUp") {
            e.preventDefault();
            $thumbSlider.slick("slickGoTo", currentIndex - 1);
        }

        if (e.key === "ArrowDown") {
            e.preventDefault();
            $thumbSlider.slick("slickGoTo", currentIndex + 1);
        }
    });

    $thumbSlider.on("afterChange", function (event, slick, currentSlide) {
        const $currentSlide = $(slick.$slides[currentSlide]);
        const altText = $currentSlide.find("img").attr("alt");
        const slideInfo = `Image ${currentSlide + 1} of ${slick.slideCount}: ${altText}`;

        // Update the live region for screen readers
        $thumbAnnouncer.text(slideInfo);

        // Optional: Move focus to the current slide wrapper so the user stays in context
        $currentSlide.attr("tabindex", "-1").trigger("focus");
    });
}

module.exports = {
    initEvents: initEvents
}
